import { createFileRoute } from '@tanstack/react-router';

import { useAuthSessionStore } from '@/modules/authentication/stores/authSessionStore';
import TenantDashboard from '@/modules/dashboard/pages/TenantDashboard';
import CompanyDashboard from '@/modules/dashboard/pages/CompanyDashboard';

export const Route = createFileRoute('/_authenticated/_system/')({
  head: () => ({
    meta: [{ title: 'Dashboard' }],
  }),
  component: function DashboardPage() {
    const { session } = useAuthSessionStore.getState();

    if (session?.organization?.company) return <CompanyDashboard />;

    return <TenantDashboard />;
  },
});
